import React from 'react';
import LoaderGif from "Social/assets/images/loader.gif";

const Loader = () => <div className="enkrip_loader common"><img src={ LoaderGif } alt='loader' title='loader'/></div>

export default Loader;
